import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-603229f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  column: "",
  wrap: "",
  class: "mx-auto"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "secretCode" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mx-auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "bg-primary" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.cardTitle), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.settingUpUser)
          ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: "First Name",
                  modelValue: _ctx.firstName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                  variant: "underlined",
                  color: "primary"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  label: "Last Name",
                  modelValue: _ctx.lastName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                  variant: "underlined",
                  color: "primary"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  label: "New Password",
                  modelValue: _ctx.newPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
                  type: "password",
                  variant: "underlined",
                  color: "primary"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.setUpUser())),
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.loginSuccessful)
            ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    name: "email",
                    label: "Email",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                    variant: "underlined",
                    color: "primary"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    name: "password",
                    label: "Password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
                    type: "password",
                    variant: "underlined",
                    color: "primary"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.login())),
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Login")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_ctx.needsOTP)
              ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
                  default: _withCtx(() => [
                    (_ctx.settingUpMFA)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Enter the OTP code to complete your MFA setup"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_text_field, {
                      name: "OTP",
                      label: "Enter OTP",
                      modelValue: _ctx.otp,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.otp) = $event)),
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.submitCode())),
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Submit")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_ctx.settingUpMFA)
                ? (_openBlock(), _createBlock(_component_v_container, { key: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Please set up your OTP by entering this code into Google Authenticator."),
                      _hoisted_3,
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.secretCode), 1),
                      _hoisted_5,
                      _createTextVNode(" Once complete, click "),
                      _createElementVNode("span", {
                        class: "text-primary link",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.goToOTP()))
                      }, "here"),
                      _createTextVNode(" to enter your code ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}